import { Role } from '../role';

export class AdminRole extends Role {
    public queryById(): null | string {
        return null;
    }

    public defaultRoute(): string {
        return this.routeManager.HOME;
    }
}
